export default function StatStrip({ data }) {
  const today = data.today;
  const year = today.slice(0, 4);
  const monthStart = today.slice(0, 8) + "01";
  const d0 = new Date(today + "T00:00:00");
  const monthEnd = new Date(d0.getFullYear(), d0.getMonth() + 1, 0).toISOString().slice(0, 10);

  const nextStart = data.next_trip?.start_date;
  const daysToNext = nextStart
    ? Math.max(0, Math.round((new Date(nextStart + "T00:00:00") - d0) / 86400000))
    : null;
  const daysInPR = data.act60?.computed?.total ?? null;
  const tripsThisMonth = (data.trips || []).filter(
    (t) => t.start_date && t.start_date <= monthEnd && (t.end_date || t.start_date) >= monthStart
  ).length;

  const cells = [
    { v: daysToNext ?? "—", label: ["DAYS TO", "NEXT TRIP"], cls: "text-ember", tid: "stat-days-to-trip" },
    { v: daysInPR ?? "—", label: ["DAYS IN PR", year], cls: "text-ink", tid: "stat-days-in-pr" },
    { v: tripsThisMonth, label: ["TRIPS", "THIS MONTH"], cls: "text-dusk", tid: "stat-trips-month" },
  ];

  return (
    <div className="bg-surface border border-hairline rounded-card flex overflow-hidden" data-testid="home-stat-strip">
      {cells.map((s, i) => (
        <div key={s.tid} className={`flex-1 px-2 py-4 text-center ${i < 2 ? "border-r border-hairline" : ""}`}>
          <p className={`font-mono text-[26px] leading-none ${s.cls}`} data-testid={s.tid}>{s.v}</p>
          <p className="font-mono text-[9px] tracking-[0.05em] text-sand-400 mt-1.5 leading-[1.3]">
            {s.label[0]}<br />{s.label[1]}
          </p>
        </div>
      ))}
    </div>
  );
}
